import React from 'react';
import { Typography, Grid } from '@mui/material';
import { PolicyCard } from '../../Shared';

/**
 * PublicPolicies - List of public policies (metadata only)
 * @param {Array} policies - Array of policy objects
 */
export const PublicPolicies = ({ policies = [] }) => {
  if (!policies || policies.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        Nenhuma política pública disponível.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {policies.map((policy, index) => (
        <Grid item xs={12} sm={6} key={policy.id || index}>
          <PolicyCard
            name={policy.title}
            version={policy.version}
            status={policy.status}
            visibility="public"
            lastUpdated={policy.lastUpdated}
          />
        </Grid>
      ))}
    </Grid>
  );
};
